/**
 * 获取首页数据
 */
import request from "_private/utils/request";

// let mock = "";

// const requestAjax = function(rOpts) {
//   let opts = {
//     url: "",
//     method: "post",
//     headers: {
//       type: "json"
//     },
//     data: {}
//   };
//   opts = Object.assign(opts, rOpts);
//   return request({
//     url: mock + opts.url,
//     method: opts.method,
//     headers: opts.headers,
//     data: opts.data
//   });
// };

// 企业红榜TOP10接口
export function FetchTopComparyRedOrder() {
  return request({
    url: "/board/alarm/getComparyRedOrder",
    method: "post"
  });
}

// 企业黑榜TOP10接口
export function FetchTopComparyBlackOrder() {
  return request({
    url: "/board/alarm/getComparyBlackOrder",
    method: "post"
  });
}

// 地图接口
export function FetchAlarmLocation() {
  return request({
    url: "/board/alarm/getAlarmLocation",
    method: "post"
  });
}

// 车/仓/柜近7日报警数量统计接口
export function FetchLast7DayAlarm() {
  return request({
    url: "/board/alarm/getLast7DayAlarm",
    method: "post"
  });
}

// 各区县报警数量统计接口
export function FetchAlarmByLocation() {
  return request({
    url: "/board/alarm/getAlarmByLocation",
    method: "post"
  });
}

// 车/仓/柜报警数量统计接口
export function FetchAlarmByScenes() {
  return request({
    url: "/board/alarm/getAlarmByScenes",
    method: "post"
  });
}

// 2020.08.26 修改 广东城市冷链配送监控看板

// 城市冷配车企业Top10接口
export function FetchComparyVehicleOrder(data) {
  return request({
    url: `/board/guangzhouMonitor/getComparyVehicleOrder?userId=${data.userId}`,
    method: "post",
    headers: { type: "json" },
    data
  });
}

// 企业冷库的吨位数接口
export function FetchStorageTonnageOrder(data) {
  return request({
    url: `/board/guangzhouMonitor/getStorageTonnageOrder?userId=${data.userId}`,
    method: "post",
    headers: { type: "json" },
    data
  });
}

// 车辆、冷库、门店地理位置接口
export function FetchLocationInfo(data) {
  return request({
    url: `/board/guangzhouMonitor/getLocationInfo?userId=${data.userId}`,
    method: "post",
    headers: { type: "json" },
    data
  });
}

// 城市冷配车在限时限行区域内的运行率接口
export function FetchVehicleOperationRate() {
  return request({
    url: "/board/guangzhouMonitor/getVehicleOperationRate",
    method: "post"
  });
}

// 冷库在线率及温度达标率接口
export function FetchStorageOnlineAndQuality() {
  return request({
    url: "/board/guangzhouMonitor/getStorageOnlineAndQuality",
    method: "post"
  });
}
// 获取运营走势数据
export function fetchCenterLeftData(data) {
  return request({
    url: `/board/guangzhouMonitor/getOperatingTrend?userId=${data.userId}`,
    headers: { type: "json" },
    method: "post",
    data
  });
}
// 获取广州冷库近7日进出次数数据
export function fetchCenterRightData(data) {
  return request({
    url: `/board/guangzhouColdMonitor/getWeekPassAreaTimes?userId=${data.userId}`,
    headers: { type: "json" },
    method: "post",
    data
  });
}
// 获取城市冷链配送车辆使用率及限行区域行驶数据
export function getBottomLeftData(data) {
  return request({
    url: `/board/guangzhouMonitor/vehicleUtilizationRate?userId=${data.userId}`,
    headers: { type: "json" },
    method: "post",
    data
  });
}
export function getBottomRightData(data) {
  return request({
    url: `/board/guangzhouColdMonitor/getPassAreaTimes?userId=${data.userId}`,
    headers: { type: "json" },
    method: "post",
    data
  });
}
export function getAvgBottomRightData(data) {
  return request({
    url: `/board/guangzhouColdMonitor/getPassAreaAvg?userId=${data.userId}`,
    headers: { type: "json" },
    method: "post",
    data
  });
}
// 获取当前用户的区域code及看看版名称
export function getUserBoardInfo(params) {
  return request({
    url: "/board/alarm/getUserBoard",
    headers: { type: "json" },
    method: "get",
    params
  });
}
// 获取自己及子用户
export function getChildUserList() {
  return request({
    url: "/base/user/child",
    headers: { type: "json" },
    method: "get"
  });
}
export function getboardUserListt() {
  return request({
    url: "/base/compary/boardUserList",
    headers: { type: "json" },
    method: "get"
  });
}

/* 广州市城市冷链配送监控看板 */

// 城市冷链配送企业排行
export function getComparyVehicleOrderNew(data) {
  return request({
    url: "/board/guangzhouMonitor/getComparyVehicleOrderNew",
    headers: { type: "json" },
    method: "post",
    data
  });
}

// 城市冷链配送车辆24小时运营走势
export function getOperatingTrendForYesterday(data) {
  return request({
    url: " /board/guangzhouMonitor/getOperatingTrendForYesterday",
    headers: { type: "json" },
    method: "post",
    data
  });
}

// 广州市限行区域晚高峰冷藏车运行情况（A,B,C）
export function getStorageTonnageOrderNew(data) {
  return request({
    url: "/board/guangzhouMonitor/getStorageTonnageOrderNew",
    headers: { type: "json" },
    method: "post",
    data
  });
}

// 进入广州重点限行区域情况
export function getKeyRestrictAreaInfo(data) {
  return request({
    url: "/board/guangzhouMonitor/getKeyRestrictAreaInfo",
    headers: { type: "json" },
    method: "post",
    data
  });
}

// 广州市冷链配送企业排行
export function getComparyVehicleOrderNewForCity(data) {
  return request({
    url: `/board/guangzhouMonitor/getComparyVehicleOrderNewForCity?userId=${data.userId}`,
    headers: { type: "json" },
    method: "post",
    data
  });
}

// 指定区域进出次数Top5
export function getInOutAreaFlow(data) {
  return request({
    url: `/board/guangzhouColdMonitor/getInOutAreaFlow?userId=${data.userId}`,
    headers: { type: "json" },
    method: "post",
    data
  });
}

// 广州冷配企业与物流节点关联度排行
export function getCompanyAndInOutAreaFlow(data) {
  return request({
    url: `/board/guangzhouColdMonitor/getCompanyAndInOutAreaFlow?userId=${data.userId}`,
    headers: { type: "json" },
    method: "post",
    data
  });
}

// 广州市范围内的冷藏车在线数量
export function getGuangZhouRunVehicleCount(data) {
  return request({
    url: `/board/guangzhouColdMonitor/getGuangZhouRunVehicleCount?userId=${data.userId}`,
    headers: { type: "json" },
    method: "post",
    data
  });
}

// 雷达图数据
export function getFlowMapData(data) {
  return request({
    url: `/reserve/vehicle/getMapData`,
    headers: { type: "json" },
    method: "post",
    data
  });
}
